<template>
  <div class="wf-anchor-bar-item">
    <a
      class="wf-anchor-bar-link"
      :href="anchor"
      :class="[
        selectedTab === id
          ? 'wf-anchor-bar-link-active'
          : 'wf-anchor-bar-link-inactive',
      ]"
      @click.stop.prevent="changeTab(id)"
    >
      {{ title }}
    </a>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

export default {
  props: {
    title: String,
    anchor: String,
    anchorType: String,
    id: String,
  },
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      selectedTab: "searchResultsPage/selectedTab",
    }),
  },
  methods: {
    ...mapActions({
      setSelectedTab: "searchResultsPage/setSelectedTab",
    }),
    changeTab(id) {
      const resultsTitle = document.querySelector('.wf-search-results-page-title');
      if (resultsTitle?.scrollIntoView) {
        resultsTitle.scrollIntoView({ behavior: "smooth" });
      }
      this.setSelectedTab(id);
    }
  },
};
</script>

<style>
</style>